import React, { useState } from "react"
import { NavLink } from "react-router-dom"
import { appRoutes } from "../../routes/appRoutes"
import Terms from "../globals/Terms"
import useLogin from "../hooks/auth/useLogin"
import PrivacyPolicy from "../globals/PrivacyPolicy"
import PasswordInput from "../elements/PasswordInput"
import Input from "../ui/Input"
import Button from "../ui/Button"

const SecretLogin: React.FC = (): React.ReactElement => {

  const loginUser = useLogin()

  const emailRegex = /^[\w-.+]+@([\w-]+\.)+[\w-]{2,4}$/g

  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [enableSubmit, setEnableSubmit] = useState<boolean>(true)
  const [validEmail, setValidEmail] = useState<boolean>(true)

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    loginUser({ email, password })
  }

  const handleEmailInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value)

    if (email.length > 0 && email.includes("@")) {
      validateEmail(email)
    }
  }

  const checkAutofillState = (event: React.FocusEvent<HTMLInputElement>) => {
    handleEmailInputChange(event)
  }

  const validateEmail = (email: string) => {
    if (email.match(emailRegex)) {
      setEnableSubmit(true)
      setValidEmail(true)
    } else {
      setEnableSubmit(false)
      setValidEmail(false)
    }
  }

  return (
    <div className="mx-auto h-full flex flex-col pt-[16px] relative">
      <div className="mb-[32px] w-full">
        <h2 className="type-heading-lg">Welcome Back!</h2>
        <p className="type-body-muted mt-[8px]">Explore, Optimize, and Transform Your Digital Presence with Data-Driven Insights</p>
      </div>
      <form method="POST" className="flex flex-col h-full items-center" onSubmit={handleSubmit}>
        <Input type="email" label="Email address" value={email} onBlur={checkAutofillState} onChange={handleEmailInputChange} error={!validEmail ? "Invalid input. Please enter a valid email address." : undefined} name="email" id="email" placeholder="user@prismancy.com" required autoComplete="email" />
        <div className="field mt-[8px]">
          <label htmlFor="current-password" className="field-label">Password</label>
          <PasswordInput name="password" value={password} onChange={(evt: React.ChangeEvent<HTMLInputElement>) => setPassword(evt.target.value)} id="confirm-password" />
          <NavLink to={appRoutes.requestPasswordReset} className="text-heading text-sm font-normal leading-5">Forgot Your Password?</NavLink>
        </div>
        <div className="h-full flex flex-col gap-2">
          <div className="w-full mt-2">
            <Button disabled={!enableSubmit} type="submit" name="submit" aria-label="Login">Login</Button>
          </div>
          <p className="type-body-muted text-center">By submitting this form, you agree to the <Terms /> and <PrivacyPolicy />.</p>
          <p className="type-body-muted text-center mb-[20px] mt-auto">
            New to Prismancy? <a href="https://forms.gle/jf2EZUQ4XD3VNtsM6" target="_blank" rel="noreferrer" className="type-link">Join the Wait List</a>
          </p>
        </div>
      </form>
    </div>
  )
}

export default SecretLogin
